import { PropertyType } from '@shared/types/estate.types';
import { sortBySpecificOrder } from '@shared/utils/sort';
import { PropertyCharacteristic } from '../../models';

const mainTagsSlugs = ['nro-cuartos', 'nro-banos', 'area', 'nro-garajes'];

export const getMainTags = (estateCharacteristics: PropertyCharacteristic[]) =>
  estateCharacteristics
    .filter((estateCharacteristic) => mainTagsSlugs.includes(estateCharacteristic.slug))
    .sort(sortBySpecificOrder(mainTagsSlugs, 'slug'));

export const MAIN_TAGS_ICONS: { [key: string]: string } = {
  'nro-cuartos': 'bed',
  'nro-banos': 'bath',
  area: 'squarem',
  'nro-garajes': 'car',
};

type Leyend = {
  short: string;
  long: string;
};
export const MAIN_TAGS_LEYEND: { [key: string]: Leyend } = {
  'nro-cuartos': {
    short: 'bedroomShortened',
    long: 'bedrooms',
  },
  'nro-banos': {
    short: 'bathroomsShortened',
    long: 'bathrooms',
  },
  'area': {
    short: 'squareMetersShortened',
    long: 'squareMeters',
  },
  'nro-garajes': {
    short: 'parkingsShortened',
    long: 'parkings',
  },
};

export const getValueFromKey = <T, K extends keyof T>(obj: T, key: K): T[K] => obj[key];
/*
  apartamento
  amoblado
  edad
  estrato
  acepta mascotas
*/

export const getPropertyType = (propertyType: PropertyType) => {
  switch (propertyType) {
    case PropertyType.APARTMENT:
      return 'Apartamento';
    case PropertyType.HOUSE:
      return 'Casa';
    default:
      return 'Apartamento';
  }
};

export const mainFeaturesSlugs = ['antiguedad', 'mascotas-permitidas', 'estrato', 'muebles', 'property-type'];

export const getMainFeatures = (estateCharacteristics: PropertyCharacteristic[]) =>
  estateCharacteristics.filter((estateCharacteristic) => mainFeaturesSlugs.includes(estateCharacteristic.slug));

export const MAIN_FEATURED_ICONS: { [key: string]: string } = {
  'property-type': 'aptunohome',
  antiguedad: 'Clock',
  'mascotas-permitidas': 'Paw',
  estrato: 'smallarrowup',
  muebles: 'Chair',
};

export const getAgeLabel = (age: string) => {
  if (age === 'Remodelado') return 'Remodelado';
  return `${age} de antiguedad`;
};

export const getFurnisehdLabel = (furnished: boolean) => (furnished ? 'furnished' : 'notFurnished');

export const getPetsFriendlyLabel = (isPetsFriendly: boolean) =>
  isPetsFriendly ? 'Se permiten mascotas' : 'No se permiten mascotas';

const excludedCharacteristicsSlugs = [
  'propiedad-nueva',
  'alta-demanda',
  'precio-negociable',
  'link-calendly',
  'video-url',
  'matterport-url',
  'tour-3d-url',
  'tipo-de-deposito',
];

export const getSecondaryFeatures = (estateCharacteristics: PropertyCharacteristic[]) =>
  estateCharacteristics.filter(
    ({ slug }) => !mainFeaturesSlugs.includes(slug) && !excludedCharacteristicsSlugs.includes(slug)
  );

export const getCharacteristicsWithValues = (estateCharacteristics: PropertyCharacteristic[]) =>
  estateCharacteristics.filter(({ withValue }) => withValue);
